import React from "react"
import {
  CardDetail,
  DetailText,
  FlatIconAndText,
  FlatIconAndText2Row,
  SwitchToggle
} from "../../../../../component/index.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { CardBody, CardHeader } from "../../../../../_metronic/_partials/controls/index.js"
import { Card } from "react-bootstrap"
import { Skeleton } from "@material-ui/lab"
import { useSelector } from "react-redux"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import { FIELD_OFFICER_ROLE_ENUM, ROUTING_STATUS } from "../../../../../constants/StringConstant.js"
import { useTranslation } from "react-i18next"

export const DetailOfficer = ({ data, activeUser, inactiveUser, role }) => {
  const { General } = useSelector((state) => state)
  const { t } = useTranslation()
  const subTitle = () => (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex flex-wrap mb-4">
          {!role && (
            <FlatIconAndText
              flatIcon="flaticon2-setting"
              text={stringFormatting(data?.role_string)}
              svg={ICON_CONSTANTS.ROLE_ACCESS}
            />
          )}

          <FlatIconAndText
            flatIcon="flaticon2-email"
            text={stringFormatting(data?.email)}
            svg={ICON_CONSTANTS.MAIL}
          />
          <FlatIconAndText
            flatIcon="flaticon2-phone"
            text={stringFormatting(data?.phone_number)}
            svg={ICON_CONSTANTS.PHONE}
          />
        </div>
        {General.loading ? (
          <>
            <Skeleton animation="wave" variant={"text"} width={250} />
            <Skeleton animation="wave" variant={"text"} width={200} />
          </>
        ) : (
          <span className="font-weight-bold text-dark-50">
            {stringFormatting(data?.full_address)}
          </span>
        )}
      </div>
    </>
  )

  const descriptionRight = (
    <>
      <div className="d-flex flex-column ">
        <SwitchToggle
          checked={activeUser === ROUTING_STATUS.STATUS_ENUM.ACTIVE}
          label={t("label_status_user")}
          onChange={inactiveUser}
          withLabel={true}
          withStatusText={true}
          statusText={
            activeUser === ROUTING_STATUS.STATUS_ENUM.ACTIVE
              ? t("label_active")
              : t("label_inactive")
          }
          disabled={activeUser === ROUTING_STATUS.STATUS_ENUM.INACTIVE}
        />
      </div>
    </>
  )
  const flatIconAndText2Rows = () => {
    return (
      <>
        {data?.role === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR && data?.field_manager_name && (
          <FlatIconAndText2Row
            title={t("label_field_manager")}
            description={stringFormatting(data?.field_manager_name)}
            enableSeparator={true}
          />
        )}
        {data?.role === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER && data?.regional_head_name && (
          <FlatIconAndText2Row
            title={t("label_regional_head")}
            description={stringFormatting(data?.regional_head_name)}
            enableSeparator={true}
          />
        )}
        {(data?.role === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR ||
          data?.role === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER) &&
          data?.sub_regional_list && (
            <FlatIconAndText2Row
              title={t("label_sub_regional")}
              description={
                data?.sub_regional_list.length > 0
                  ? data?.sub_regional_list.map((item) => item.name).join(", ")
                  : "-"
              }
            />
          )}
        {data?.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER && data?.field_supervisor_name && (
          <FlatIconAndText2Row
            title={t("label_field_supervisor")}
            description={stringFormatting(data?.field_supervisor_name)}
          />
        )}
        {data?.role === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD && data?.regional_name && (
          <FlatIconAndText2Row
            title={t("label_regional")}
            description={stringFormatting(data?.regional_name)}
          />
        )}
      </>
    )
  }
  return (
    <>
      <RowModule>
        {activeUser === ROUTING_STATUS.STATUS_ENUM.INACTIVE && (
          <RowModule>
            <Card className={"bg-neutral-light-gray"}>
              <CardHeader
                title={t("card_title_status_change_reason")}
                className="mb-0 pb-2 bg-neutral-light-gray"
              />
              <CardBody>{data?.field_officer_deactivation_reason}</CardBody>
            </Card>
          </RowModule>
        )}
      </RowModule>
      <RowModule withoutSeparator={true}>
        <CardDetail
          titleImage={data?.url_profile}
          titleCardDetail={data?.name}
          descriptionLeft={subTitle()}
          descriptionRight={descriptionRight}
          flatIconAndText2Rows={flatIconAndText2Rows()}
          wrap={false}
        />
      </RowModule>
      {data?.url_profile &&
        data?.role !== FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD &&
        data?.role !== FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER && (
          <RowModule withoutSeparator={true} customColumnCss="col-lg-6 col-sm-6 col-md-6">
            <DetailText
              title={t("label_profile_picture").toUpperCase()}
              menu="AVATAR"
              value={data?.url_profile}
              type="image"
              withoutSeparator={true}
            />
          </RowModule>
        )}
    </>
  )
}